// extracted by mini-css-extract-plugin
export default {"location-dropdown__icon":"location-dropdown__icon--f4TTV","locationDropdownIcon":"location-dropdown__icon--f4TTV"};